import li from "./li";
import modalWindow from "./modalWindow";
import cities from "./cities";

export default {
  cities,
  li,
  modalWindow,
};
